export default __webpack_public_path__ + "static/media/H1005.5.290a59e5.mp3";